import { z } from 'my-zod'
import { tableViewAdminView } from './table-view-admin-view'

export const tableViewDefaultView = tableViewAdminView
  .pick({
    search: true,
    order: true,
    sorting: true,
    columnWidths: true,
    filters: true,
    grouping: true,
    visibleColumns: true,
    summaries: true
  })
  .augment({
    order: tableViewAdminView.shape.order.optional(),
    sorting: tableViewAdminView.shape.sorting.optional(),
    columnWidths: tableViewAdminView.shape.columnWidths.optional()
  })
export type tableViewDefaultView = z.infer<typeof tableViewDefaultView>
